var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.showing)?_c('div',{staticClass:"mtx-modal",on:{"click":_vm.onClick,"keydown":_vm.onKeydown}},[_c('div',{ref:"content",staticClass:"mtx-modal__content px-2 py-2",style:({
        width: _vm.width || false,
        maxWidth: _vm.maxWidth || false
      }),attrs:{"tabindex":"-1","role":"dialog"}},[_c('MtxCard',[_vm._t("default",null,{"hide":_vm.hide})],2)],1)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }